var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4395 1.9395C18.1583 1.65818 17.7768 1.50008 17.379 1.5H3C1.34315 1.5 0 2.84315 0 4.5V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V8.121C23.9999 7.72321 23.8418 7.34174 23.5605 7.0605L18.4395 1.9395ZM18 3.621L21.879 7.5H18V3.621ZM21 21C21.8284 21 22.5 20.3284 22.5 19.5V9H18C17.1716 9 16.5 8.32843 16.5 7.5V3H3C2.17157 3 1.5 3.67157 1.5 4.5V19.5C1.5 20.3284 2.17157 21 3 21H21ZM6 15V18H4.5V15H6ZM4.5 13.5H6C6.82843 13.5 7.5 14.1716 7.5 15V18C7.5 18.8284 6.82843 19.5 6 19.5H4.5C3.67157 19.5 3 18.8284 3 18V15C3 14.1716 3.67157 13.5 4.5 13.5ZM12 7.5V18H10.5V7.5H12ZM10.5 6H12C12.8284 6 13.5 6.67157 13.5 7.5V18C13.5 18.8284 12.8284 19.5 12 19.5H10.5C9.67157 19.5 9 18.8284 9 18V7.5C9 6.67157 9.67157 6 10.5 6ZM18 18H16.5V12H18V18ZM16.5 10.5H18C18.8284 10.5 19.5 11.1716 19.5 12V18C19.5 18.8284 18.8284 19.5 18 19.5H16.5C15.6716 19.5 15 18.8284 15 18V12C15 11.1716 15.6716 10.5 16.5 10.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/element.b07652a7298179d8873dc80185602a21.svg";